import axios from 'axios';

export const getAchievement = async (repo_id, id) => {
    // Llamada a la API para obtener el certificado
    const response = await axios.get(
        `${process.env.REACT_APP_REPO}/v1/repo_aden/students/${repo_id}/badges/${id}`
    );
    return response.data.response_data.response;
};
